export enum CloudflareAction {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
}

export type CloudflareActionProps = {
  type: CloudflareAction;
};
